import ArticleDetailScreen from 'screens/ArticleDetail';
import ChannelScreen from 'screens/Channel';
import CollectionScreen from 'screens/Collection';
import ContentDetailScreen from 'screens/ContentDetail';
import DebugScreen from 'screens/Debug';
import Error404Screen from 'screens/Error404';
import Error500Screen from 'screens/Error500';
import FindScreen from 'screens/Find';
import GeoBlock from 'screens/GeoBlock';
import LatestEpisodeScreen from 'screens/LatestEpisode';
import LiveScreen from 'screens/Live';
import LoadingScreen from 'screens/Loading';
import MVPDScreen from 'screens/MVPD';
import PersonalityScreen from 'screens/Personality';
import SiteMapScreen from 'screens/SiteMap';
import WatchScreen from 'screens/Watch';
import WatchV2Screen from 'screens/WatchV2';
import WatchlistScreen from 'screens/Watchlist';

import generator from './routes-generator';

export default generator({
  ArticleDetailScreen,
  ChannelScreen,
  CollectionScreen,
  ContentDetailScreen,
  DebugScreen,
  Error404Screen,
  Error500Screen,
  FindScreen,
  GeoBlock,
  LatestEpisodeScreen,
  LiveScreen,
  LoadingScreen,
  MVPDScreen,
  PersonalityScreen,
  SiteMapScreen,
  WatchlistScreen,
  WatchScreen,
  WatchV2Screen,
});
